import { render } from "./LegacyEvents.vue?vue&type=template&id=27fc1f90"
import script from "./LegacyEvents.vue?vue&type=script&lang=js"
export * from "./LegacyEvents.vue?vue&type=script&lang=js"
script.render = render

export default script